import React, { useEffect, useState } from 'react';
import GalleryFlat1 from '../GalleriesFlat/GalleryFlat1';
import GalleryFlat2 from '../GalleriesFlat/GalleryFlat2';
import QA1 from './QA1';
import QA2 from './QA2';
import QA3 from './QA3';
import QA4 from './QA4';
import './Sections.scss';
import WalkingThroughVerona from './WalkingThroughVerona';
import Quotes from '../Quotes/Quotes';
import flower from '../../assets/flower.svg';
import fullbleed1 from '../../assets/fullbleed1.png';
import fullbleed2 from '../../assets/fullbleed2.png';

import inline2 from '../../assets/interview4/inline2.png';
import inline3 from '../../assets/inline3.png';
import inline6 from '../../assets/inline6.png';
import inline7 from '../../assets/inline7.png';
import inline5 from '../../assets/inline5.png';
import Video1 from '../Videos/Video1';
import QA5 from './QA5';
import QA6 from './QA6';
import GalleryFlat3 from '../GalleriesFlat/GalleryFlat3';
import QA7 from './QA7';
import QA8 from './QA8';
import Video2 from '../Videos/Video2';
import QA9 from './QA9';
import GalleryFlat4 from '../GalleriesFlat/GalleryFlat4';
import carousel1 from '../../assets/galleries/carousel/img1.png';
import carousel2 from '../../assets/galleries/carousel/img2.png';
import carousel3 from '../../assets/galleries/carousel/img3.png';
import carousel4 from '../../assets/galleries/carousel/img4.png';
import carousel5 from '../../assets/galleries/carousel/img5.png';
import Gallery from '../Galleries/Gallery';

import Explore from './Explore';
import QAAdd from './QAAdd';

function Sections() {
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  useEffect(() => {
    window.addEventListener(
      'touchstart',
      function onFirstTouch() {
        setIsTouchScreen(true);
        window.removeEventListener('touchstart', onFirstTouch, false);
      },
      false
    );
  }, []);
  const quotesContent = {
    copy: `“Flowers represent romanticism, they are a symbol of love.”`
  };
  const quotesContent2 = {
    copy: `Every piece of Roberto Coin jewelry features his magical signature, a single ruby hidden inside. “A  touch of luck for our clients.”`,
    class: 'quote2'
  };
  const quotesContent3 = {
    copy: `“Beauty is really everywhere. We are surrounded by it. It has always been my mission to search continuously for beauty. And to share it.”`
  };

  const galleryContents = [
    {
      img: carousel1,
      caption:
        'Each piece of Roberto Coin jewelry begins its life as a 3D model. The model is then 3D-printed using a special wax, and the wax ’tree’ is used to cast the designs in gold.'
    },
    {
      img: carousel2,
      caption: 'A jeweler files the gold on the clasp of a Love in Verona bracelet.'
    },
    {
      img: carousel3,
      caption:
        'Princess Flower pendant. At Roberto Coin, each diamond is individually checked before setting to ensure that it is a natural diamond.'
    },
    {
      img: carousel4,
      caption:
        '”Attention, please engrave the brand stamp.” A tray of Venetian Princess pendants awaits engraving.'
    },
    {
      img: carousel5,
      caption: 'As part of the finishing process, each piece is polished by hand.'
    }
  ];

  return (
    <main className="section">
      <WalkingThroughVerona />
      <div className="interview1__flowers">
        <img className="flower" src={flower} alt="" />
        <img className="flower" src={flower} alt="" />
        <img className="flower" src={flower} alt="" />
      </div>
      <QA1 />
      <GalleryFlat1 />
      <QA2 />

      <img className="mainSize" src={fullbleed1} alt="" />

      <QA3 />
      <Video1 />
      <img className="flower interview2__flower" src={flower} alt="" />
      <GalleryFlat2 />
      <QA4 />
      <div className="interview__inline2__container">
        <img src={inline2} alt="" className="interview__inline2" />
        <p className="caption interview__caption">
          Juliet’s Balcony at <span className="caption--italic">La Casa di Giulietta</span> in
          Verona.
        </p>
      </div>
      <Quotes quotesContent={quotesContent} />
      <QA5 />
      <div className="interview__interview">
        <img src={inline3} alt="" className="mainSize" />
        <p className="caption">
          Roberto Coin notes the floral design in the windows at the Juliet House.
        </p>
      </div>
      <QA6 />
      <GalleryFlat3 />
      <QA7 />
      <img src={fullbleed2} alt="" className="mainSize" />
      <QA8 />
      <Gallery galleryContents={galleryContents} isTouchScreen={isTouchScreen} />
      <QAAdd />
      <div className="interview__inline56">
        <img
          className="interview__inline56__photo interview__inline56__photo--left"
          src={inline5}
          alt=""
        />
        <img className="interview__inline56__photo" src={inline6} alt="" />
      </div>

      <Quotes quotesContent={quotesContent2} />
      <Video2 />
      <GalleryFlat4 />
      <QA9 />
      <img className="interview__inline7" src={inline7} alt="" />
      <Quotes quotesContent={quotesContent3} />
      <Explore />
    </main>
  );
}

export default Sections;
